module.exports = __webpack_public_path__ + "static/media/new-conversation.8c843675.mp3";